import { writable } from 'svelte/store';
export const spotifyUrl = writable(undefined);
export const spotifyAccessToken = writable(undefined);
export const spotifyPlayerStatus = writable('disconnected');
export const spotifyUserData = writable(undefined);
export const spotifyPlayerState = writable(undefined);
export const nextSpotifySongEnd = writable(undefined);
;
export const geniusLink = writable(null);
;
